import { type RouteConfig } from 'vue-router'

export const ScenesRouter: RouteConfig[] = [
  {
    path: '/scenes',
    component: async () => import('./Scenes.vue'),
  },
]
